import axios from 'axios'
import qs from 'qs'
// import { Message } from 'element-ui'
import store from '@/store'
import { getToken, removeUserName } from '@/utils/auth'
import router from '@/router'
// create an axios instance
export const requestJson = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 300000 // request timeout
})

// request interceptor
requestJson.interceptors.request.use(config => {
  // Do something before request is sent
  if (store.getters.token) {
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['X-Token'] = getToken()
  }
  config.headers['storeType'] = store.getters.storeType
  config.headers['openId'] = store.getters.openId
  config.headers['token'] = store.getters.token
  config.headers['shopId'] = store.getters.shopId
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
requestJson.interceptors.response.use(
  response => {
    if (response.status == 405) {
      /*if (confirm('你已退出登录，可以取消继续留在该页面，或者确定重新登录')) {
        location.reload();
      }*/
      if (getUserName()) {

          router.replace({
            path: '/login'
          });

      }

      return;
    }
    return response;
  },
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  // response => {
  //   const res = response.data
  //   if (res.code !== 20000) {
  //     Message({
  //       message: res.message,
  //       type: 'error',
  //       duration: 5 * 1000
  //     })
  //     // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //     if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //       // 请自行在引入 MessageBox
  //       // import { Message, MessageBox } from 'element-ui'
  //       MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //         confirmButtonText: '重新登录',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {
  //         store.dispatch('FedLogOut').then(() => {
  //           location.reload() // 为了重新实例化vue-router对象 避免bug
  //         })
  //       })
  //     }
  //     return Promise.reject('error')
  //   } else {
  //     return response.data
  //   }
  // },
  error => {
    console.log('err' + error) // for debug
    /* Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    }) */
    return Promise.reject(error)
  }
)

export function doJsonPost(url, param, successCallback, failCallback) {
  requestJson.post(url, param).then(function(response) {
    if (response.status === 200 ) {
      // 判断后台是否退出登陆
      if (response.data == 'logonout') {
        if (confirm('你已退出登录，可以取消继续留在该页面，或者确定重新登录')) {
          location.reload();
        }
      } else {
        if (successCallback) {
          successCallback(response.data);
        }
      }
    } else if (response.status === 401) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (response.status === 418) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }  else {
      removeUserName();
      if (failCallback) {
        failCallback(response);
      }
    }
  }).catch(function(error) {
    console.log(error);
    if (405 == error.response.status) {
      removeUserName();
      router.replace({
        path: '/login'
      });
    }else if (401 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (418 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    } else if (404 == error.response.status) {
      if (failCallback) {
        failCallback(error);
      }
    }
  });
}

export function syncJsonPost(url, param) {
  var requestResult = {
    result: false,
    message: '网络错误'
  }
  return new Promise((resolve, reject) => {
    requestJson.post(url, param).then(function(response) {
      if (response.status === 200) {
        // 判断后台是否退出登陆
        if (response.data == 'logonout') {
          if (confirm('你已退出登录，可以取消继续留在该页面，或者确定重新登录')) {
            location.reload();
          }
        } else {
          requestResult = response.data;
        }
      } else {
        removeUserName();
      }
      resolve(requestResult);
    }).catch(function(error) {
      console.log(error);
      if (405 == error.response.status) {
        removeUserName();
        router.replace({
          path: '/login'
        });
      }else if (401 === error.response.status) {
        wx.miniProgram.reLaunch({
          url: '/pages/index/index'
        })
      }else if (418 === error.response.status) {
        wx.miniProgram.reLaunch({
          url: '/pages/index/viewIndex'
        })
      }
      reject(error);
    })
  });
}

export function doJsonGet(url, param, successCallback, failCallback) {
  requestJson.get(url, {
    paraJson: 'paraJson'
  }).then(function(response) {
    if (response.status === 200) {
    	if (successCallback) {
    	  successCallback(response.data);
    	} else {
    	  if (successCallback) {
    	    successCallback(response.data);
    	  }
      }
    } else if (response.status === 401) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (response.status === 418) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }  else {
      removeUserName();
      if (failCallback) {
        failCallback(response);
      }
    }
  }).catch(function(error) {
    console.log(error);
    if (405 == error.response.status) {
      removeUserName();
      router.replace({
        path: '/login'
      });
    }else if (401 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (418 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }
  })
}

export function doFilePost(url, param, successCallback, failCallback) {
  requestForm.post(url,param, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(function(response) {
    if (response.status === 200) {
      if (response.data=="logonout") {
        if (confirm("你已退出登录，可以取消继续留在该页面，或者确定重新登录")) {
          location.reload();
        }
      } else {
        if (successCallback) {
          successCallback(response.data);
        }
      }
    } else {
      removeUserName();
      if (failCallback) {
        failCallback(response);
      }
    }
  }).catch(function(error) {
    console.log(error);
    if (405 == error.response.status) {
      removeUserName();
      router.replace({
        path: '/login'
      });
    }else if (401 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (418 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }
  })
}

// create an axios instance
export const requestForm = axios.create({
  baseURL:  process.env.BASE_API, // api的base_url
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'storeType': store.getters.storeType
  },
  timeout: 30000 // request timeout
})
requestForm.interceptors.request.use(config => {
  // Do something before request is sen
  config.headers['storeType'] = store.getters.storeType
  config.headers['token'] = store.getters.token
  config.headers['openId'] = store.getters.openId
  config.headers['shopId'] = store.getters.shopId
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
export function doFileFormPost(url, param, successCallback, failCallback) {
  requestForm.post(url,qs.stringify(param), {
    responseType: "arraybuffer"
  }).then(function(response) {
    successCallback(response);
  }).catch(function(error) {
    console.log(error);
  })
}
export function doFileFormGet(url, param, successCallback, failCallback) {
  requestForm.get(url, {
    params: param, // 将参数传递给请求
    responseType: "blob", // 确保响应类型为 blob
  })
    .then(function (response) {
      successCallback(response); // 将响应传递给成功回调
    })
    .catch(function (error) {
      if (failCallback) {
        failCallback(error); // 将错误传递给失败回调
      } else {
        console.error("请求失败:", error);
      }
    });
}
export function doFormPost(url, param, successCallback, failCallback) {
  requestForm.post(url, qs.stringify(param)).then(function(response) {
    if (response.status === 200) {
    	if (response.data=="logonout") {
        if (confirm("你已退出登录，可以取消继续留在该页面，或者确定重新登录")) {
          location.reload();
        }
      } else {
        if (successCallback) {
        	successCallback(response.data);
        }
      }
    } else if (response.status === 401) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (response.status === 418) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }else {
      removeUserName();
      if (failCallback) {
        failCallback(response);
      }
    }
  }).catch(function(error) {
    console.log(error);
    if (405 == error.response.status) {
      removeUserName();
      router.replace({
        path: '/login'
      });
    } else if (401 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (418 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }
  })
}

export function syncFormPost(url, param) {
  var requestResult = {
    result: false,
    message: '网络错误'
  }
  return new Promise((resolve, reject) => {
    requestForm.post(url, qs.stringify(param)).then(function(response) {
      if (response.status === 200) {
        if (response.data=="logonout") {
          if (confirm("你已退出登录，可以取消继续留在该页面，或者确定重新登录")) {
            location.reload();
          }
        } else {
          requestResult = response.data;
        }
      } else if (response.status === 401) {
        wx.miniProgram.reLaunch({
          url: '/pages/index/index'
        })
      }else if (response.status === 418) {
        wx.miniProgram.reLaunch({
          url: '/pages/index/viewIndex'
        })
      } else {
        removeUserName();
      }
      resolve(requestResult);
    }).catch(function(error) {
      console.log(error);
      if (405 == error.response.status) {
        removeUserName();
        router.replace({
          path: '/login'
        });
      }
      reject(error);
    });
  });
}

export function doFormGet(url, param, successCallback, failCallback) {
  requestForm.get(url, {
    paraJson: 'paraJson'
  }).then(function(response) {
    if (response.status === 200) {
      if(response.data=="logonout"){
        if(confirm("你已退出登录，可以取消继续留在该页面，或者确定重新登录")){
          location.reload();
        }
      }else{
        if (successCallback) {
          successCallback(response.data)
        }
      }
    } else if (response.status === 401) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }  else if (response.status === 418) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    } else {
      removeUserName();
      if (failCallback) {
        failCallback(response)
      }
    }
  }).catch(function(error) {
    console.log(error);
    if (405 == error.response.status) {
      removeUserName();
      router.replace({
        path: '/login'
      });
    }else if (401 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    }else if (418 === error.response.status) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/viewIndex'
      })
    }
  })
}

/*
export default service
*/



// WEBPACK FOOTER //
// ./src/utils/request.js